function ichigayaGetElementFromHash(hash) {
  if (!hash || hash === '#') {
    return null;
  }

  var id = hash.slice(1);
  try {
    id = decodeURIComponent(id);
  } catch (e) {
    return null;
  }

  return document.getElementById(id);
}

function ichigayaAnimateScrollTo(el) {
  var $target = $(el);
  var scrollMargin = parseInt($target.css('scrollMarginTop'), 10) || 0;
  var targetY =
    scrollMargin > 0
      ? $target.offset().top - scrollMargin
      : $target.offset().top - ($('.header').outerHeight(true) || 0);
  var startY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var distance = targetY - startY;

  if (Math.abs(distance) < 1) {
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo(0, targetY);
    return;
  }

  var duration = 500;
  var startTime = null;

  function step(timestamp) {
    if (!startTime) {
      startTime = timestamp;
    }

    var progress = Math.min((timestamp - startTime) / duration, 1);
    var eased = 0.5 - Math.cos(progress * Math.PI) / 2;
    window.scrollTo(0, startY + distance * eased);

    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

$(document).on('click', 'a[href^="#"]', function (e) {
  if (this.classList.contains('p-toc__link')) {
    return;
  }

  var el = ichigayaGetElementFromHash(this.hash);
  if (!el) {
    return;
  }

  e.preventDefault();
  ichigayaAnimateScrollTo(el);
  return false;
});

// ハッシュ付きURLで開いたとき
var urlHash = location.hash;
if (urlHash) {
  $('body,html').stop().scrollTop(0);
  window.setTimeout(function () {
    var el = ichigayaGetElementFromHash(urlHash);
    if (!el) {
      return;
    }
    ichigayaAnimateScrollTo(el);
  }, 100);
}

// SP nav
$(document).ready(function () {

  // ハンバーガー開閉
  $('.js-nav-bt').on('click', function (e) {
    e.stopPropagation();
    $('.js-nav-content, .js-nav-logo, .js-nav-bt')
      .toggleClass('is-navOn');
  });

  // SPのときだけ、リンクを押したら閉じる
  $('.js-nav-bt.is-navOn, .js-nav-logo.is-navOn, .js-nav-link')
  .not('.is-subLink .js-nav-link')
  .on('click', function (e) {

    if (window.innerWidth < 768) {
      $(".js-nav-content, .js-nav-logo, .js-nav-bt")
        .removeClass('is-navOn');
    }
});

  // 診療案内（SP）: タップでサブメニュー開閉
  // ※ ready 外＋matchMedia 初回のみだと、DOM 未生成で 0 件バインド／PC幅で開くと未登録になるため委譲＋幅判定に統一
  $(document).on('click', '.is-subLink > .js-nav-link', function (e) {
    if (window.innerWidth >= 768) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();

    const $parent = $(this).closest('.is-subLink');
    const $sub = $parent.find('.subLink');
    const $plus = $parent.find('.js-sp-navDown');

    $('.subLink').not($sub).slideUp();
    $('.js-sp-navDown').not($plus).removeClass('is-on');

    $sub.stop(true, true).slideToggle();
    $plus.toggleClass('is-on');
  });

  $(document).on('click', '.js-sp-navDown', function (e) {
    if (window.innerWidth >= 768) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();

    const $sub = $(this).next();

    $('.subLink').not($sub).slideUp();
    $('.js-sp-navDown').not(this).removeClass('is-on');

    $sub.stop(true, true).slideToggle();
    $(this).toggleClass('is-on');
  });

  $(window).on('scroll', function () {
    const sliderHeight = $('.topMv').height();
    if (!sliderHeight) {
      return;
    }
    if (sliderHeight - 30 < $(this).scrollTop()) {
      $('.js-header-sp').addClass('is-headerOn');
    } else {
      $('.js-header-sp').removeClass('is-headerOn');
    }
  });

  $(window).on('scroll', function () {
    const scrollHeight = $(document).height();
    const scrollPosition = $(window).height() + $(window).scrollTop();
    const footHeight = $('.js-footer-sp').innerHeight();
    if (scrollHeight - scrollPosition <= footHeight) {
      $('.js-cv-sp').addClass('is-none');
    } else {
      $('.js-cv-sp').removeClass('is-none');
    }
  });
});

jQuery(function($) {
  //tab
  $(function () {
    $('.js-tab .js-tabItem').click(function () {
      var index = $('.js-tab .js-tabItem').index(this);
      $('.js-tab .js-tabItem').removeClass('is-on');
      $(this).addClass('is-on');
      $('.js-tabArea .js-tabcCntents').removeClass('is-on').eq(index).addClass('is-on');
    });
  });
});
